import React, { useEffect } from 'react';
import { initGA } from './services/analyticsService';

// importing MyRouts where we located all of our theme
import MyRouts from './routers/routes'

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <div>
      <MyRouts />
    </div>
  );
}

export default App;
